<div
  class="fixed bottom-0 left-0 z-50 w-11/12 h-screen p-4 overflow-y-auto transition-transform duration-300 transform -translate-x-full bg-white md:w-72 dark:bg-gray-800"
  [class.translate-x-0]="isOpen"
  [class.-translate-x-full]="!isOpen"
>
  <div class="absolute left-5 max-h-12">
    <img src="./assets/images/logo/logo_inline_color.svg" width="150px" />
  </div>

  <button
    (click)="close()"
    type="button"
    class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-xl absolute end-2.5 flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white h-8 w-8"
  >
    <Icon src="close" class="mt-1" />
    <span class="sr-only">Close menu</span>
  </button>

  <div class="py-2 pt-12 overflow-y-auto">
    <div class="flex flex-col items-center justify-start mb-5">
      <div class="flex items-center w-full p-4 mb-2">
        <!-- Nome e unidade -->
        <div class="flex flex-col w-full">
          <!-- Unidade como botão -->

          <ng-container
            *ngIf="
              authService.hasRole('ADMIN_TROCA_UNIDADE');
              else onlyBranchText
            "
          >
            <button
              title="Trocar unidade"
              type="button"
              (click)="changeBranch()"
              class="flex items-center mb-1 group focus:outline-none"
            >
              <div
                class="w-4 h-4 rounded-md me-2"
                [style.background]="'color_cod' | branch"
              ></div>
              <span
                class="font-semibold truncate text-zinc-600 group-hover:underline"
              >
                {{ "name" | branch }}
              </span>
            </button>
          </ng-container>

          <ng-template #onlyBranchText>
            <div class="flex items-center mb-1">
              <div
                class="w-4 h-4 rounded-md me-2"
                [style.background]="'color_cod' | branch"
              ></div>
              <span
                class="font-semibold truncate text-zinc-600 group-hover:underline"
              >
                {{ "name" | branch }}
              </span>
            </div>
          </ng-template>

          <!-- Usuário -->
          <div class="flex items-center text-sm font-medium text-zinc-600/90">
            <Icon src="users" class="text-base me-2"></Icon>
            <span class="truncate">{{ "name" | me }}</span>
          </div>
        </div>
      </div>

      <div class="flex flex-col justify-center w-full">
        <button
          (click)="close()"
          [routerLink]="['/auth/logout']"
          [class]="classLinks"
        >
          <i class="icon-door-exit"
            ><span class="path1"></span><span class="path2"></span
          ></i>
          Sair
        </button>

        <div class="space-y-2 font-medium">
          <hr class="my-2 mb-3" />

          <SidebarLink
            *HasRole="['RESERVA']"
            (clicked)="close()"
            icon="calendar"
            label="Reservas"
            link="/reservas"
          />

          <span *HasRole="['ENTRADA', 'CHECKLIST']">
            <button
              type="button"
              (click)="openMenu('entradas')"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-t-lg disabled:opacity-40 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
              [ngClass]="{
                'bg-blue-900 text-white hover:bg-gray-300': menus.entradas.open,
              }"
            >
              <Icon src="barrier" class="me-1" />
              <span class="flex-1 text-left rtl:text-right whitespace-nowrap"
                >Entradas</span
              >
              <Icon [src]="!menus.entradas.open ? 'arrow-down' : 'arrow-up'" />
            </button>
            <ul
              class="p-2 space-y-2 bg-gray-300 rounded-b-lg"
              [ngClass]="{ hidden: !menus.entradas.open }"
            >
              <li *HasRole="['ENTRADA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="barrier"
                  label="Entrada"
                  link="/entrada"
                />
              </li>
              <li>
                <SidebarLink
                  (clicked)="close()"
                  icon="fa-solid fa-camera"
                  [useFontAwsome]="true"
                  label="Alertas das camêras"
                  link="/camera/alertas"
                />
              </li>
              <li *HasRole="['CHECKLIST']">
                <SidebarLink
                  (clicked)="close()"
                  icon="checklist"
                  label="Checklists"
                  link="/checklists"
                />
              </li>
            </ul>
          </span>

          <span *HasRole="['PENDENTE', 'PATIO']">
            <button
              type="button"
              (click)="openMenu('patio')"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-t-lg disabled:opacity-40 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
              [ngClass]="{
                'bg-blue-900 text-white hover:bg-gray-300': menus.patio.open,
              }"
            >
              <Icon src="patio" class="me-1" />
              <span class="flex-1 text-left rtl:text-right whitespace-nowrap"
                >Pátio</span
              >
              <Icon [src]="!menus.patio.open ? 'arrow-down' : 'arrow-up'" />
            </button>
            <ul
              class="p-2 space-y-2 bg-gray-300 rounded-b-lg"
              [ngClass]="{ hidden: !menus.patio.open }"
            >
              <li *HasRole="['PENDENTE']">
                <SidebarLink
                  (clicked)="close()"
                  icon="car-pending"
                  label="Pendentes"
                  link="/v2/patio/pendentes"
                />
              </li>
              <li *HasRole="['PATIO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="patio"
                  label="Pátio"
                  link="/v2/patio"
                />
              </li>
            </ul>
          </span>

          <SidebarLink
            *HasRole="['CAIXA']"
            (clicked)="close()"
            icon="wallet"
            label="Caixa"
            link="/caixa"
          />
          <SidebarLink
            *HasRole="['CONFERENCIA']"
            (clicked)="close()"
            icon="conference"
            label="Conferências"
            link="/conferencias"
          />
          <SidebarLink
            *HasRole="['PAINEL_CONTROLE']"
            (clicked)="close()"
            icon="reports"
            label="Painel de controle"
            link="/painel-de-controle"
          />

          <span *HasRole="adminAccess">
            <button
              type="button"
              (click)="openMenu('admin')"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-t-lg disabled:opacity-40 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
              [ngClass]="{
                'bg-blue-900 text-white hover:bg-gray-300': menus.admin.open,
              }"
            >
              <Icon src="admin" class="me-1" />
              <span class="flex-1 text-left rtl:text-right whitespace-nowrap"
                >Administração</span
              >
              <Icon [src]="!menus.admin.open ? 'arrow-down' : 'arrow-up'" />
            </button>
            <ul
              class="p-2 space-y-2 bg-gray-300 rounded-b-lg"
              [ngClass]="{ hidden: !menus.admin.open }"
            >
              <li *HasRole="['ADMIN_PARAMETRO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="fa-solid fa-marker"
                  [useFontAwsome]="true"
                  label="Parametros"
                  link="/painel-de-controle/parametros"
                />
              </li>
              <li *HasRole="['ADMIN_ENTRADA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="barrier"
                  label="Entradas"
                  link="/painel-de-controle/entradas"
                />
              </li>
              <li *HasRole="['ADMIN_CAIXA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="wallet"
                  label="Caixas"
                  link="/painel-de-controle/caixas"
                />
              </li>
              <li *HasRole="['ADMIN_CARTAO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="fa-solid fa-id-card"
                  [useFontAwsome]="true"
                  label="Cartões"
                  link="/painel-de-controle/cartoes"
                />
              </li>
              <li *HasRole="['ADMIN_CLIENTE']">
                <SidebarLink
                  (clicked)="close()"
                  icon="fa-solid fa-users-gear"
                  [useFontAwsome]="true"
                  label="Clientes"
                  link="/painel-de-controle/clientes"
                />
              </li>
              <li *HasRole="['ADMIN_CONTRATO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="agreement"
                  label="Contratos"
                  link="/painel-de-controle/contratos"
                />
              </li>
              <li *HasRole="['ADMIN_DESPESA_RECEITA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="moneys"
                  label="Despesas e Receitas"
                  link="/painel-de-controle/despesas-receitas/titulos"
                />
              </li>
              <li *HasRole="['ADMIN_VEICULO_MODELO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="vehicle-model"
                  label="Modelos"
                  link="/painel-de-controle/modelos-de-veiculos"
                />
              </li>
              <li *HasRole="['ADMIN_MENSALISTA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="mensalista"
                  label="Mensalistas"
                  link="/painel-de-controle/mensalistas"
                />
              </li>
              <li *HasRole="['ADMIN_EMPRESA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="fa-solid fa-handshake"
                  [useFontAwsome]="true"
                  label="Parceiros"
                  link="/painel-de-controle/empresas"
                />
              </li>
              <li *HasRole="['ADMIN_USUARIO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="users"
                  label="Usuários"
                  link="/painel-de-controle/usuarios"
                />
              </li>
              <li *HasRole="['ADMIN_VAGA']">
                <SidebarLink
                  (clicked)="close()"
                  icon="patio"
                  [useFontAwsome]="false"
                  label="Vagas"
                  link="/painel-de-controle/vagas"
                />
              </li>
              <li *HasRole="['ADMIN_VEICULO']">
                <SidebarLink
                  (clicked)="close()"
                  icon="car-sided-left"
                  label="Veículos"
                  link="/painel-de-controle/veiculos"
                />
              </li>
              <li *HasRole="['ADMIN_UNIDADE']">
                <SidebarLink
                  (clicked)="close()"
                  icon="buildings"
                  label="Unidades"
                  link="/painel-de-controle/unidades"
                />
              </li>
            </ul>
          </span>

          <span *HasRole="['DASHBOARD']">
            <button
              type="button"
              (click)="openMenu('dash')"
              class="flex items-center w-full p-2 text-base text-gray-900 transition duration-75 rounded-t-lg disabled:opacity-40 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
              [ngClass]="{
                'bg-blue-900 text-white hover:bg-gray-300': menus.dash.open,
              }"
            >
              <Icon
                src="fa-solid fa-chart-line"
                [useFontAwsome]="true"
                class="me-1"
              />
              <span class="flex-1 text-left rtl:text-right whitespace-nowrap"
                >Dashboards</span
              >
              <Icon [src]="!menus.dash.open ? 'arrow-down' : 'arrow-up'" />
            </button>
            <ul
              class="p-2 space-y-2 bg-gray-300 rounded-b-lg"
              [ngClass]="{ hidden: !menus.dash.open }"
            >
              <li *HasRole="['DASHBOARD']">
                <SidebarLink
                  (clicked)="close()"
                  icon="fa-solid fa-marker"
                  [useFontAwsome]="true"
                  label="Visão Geral"
                  link="/dashboard/visao-geral-empresa"
                ></SidebarLink>
              </li>
            </ul>
          </span>

          <hr class="my-2 mb-3" />

          <!-- <SidebarLink (clicked)="close()" icon="school" label="Tutoriais" link="/tutoriais" /> -->

          <SidebarLink
            (clicked)="close()"
            icon="code"
            label="Litwo"
            (click)="goToLitwo()"
          />

          <hr class="my-2 mb-3" />

          <div
            class="mx-3 text-sm border-t border-gray-500 opacity-50 dark:opacity-25"
          >
            Versão: {{ versionService.get }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  (click)="close()"
  class="absolute top-0 left-0 z-40 w-screen h-screen transition-all bg-zinc-900/60 backdrop-blur-sm backdrop-saturate-150"
></div>
